import { pipe } from 'ramda'
import {
  setAction,
  setLabel,
  setReceivedLabel,
} from '@creditas-lab/analytics-events'
import { dispatchFrontendLoginEvent } from './commons'

const dispatchClickToSignup = pipe(
  setAction('user_click_to_signup'),
  dispatchFrontendLoginEvent,
)

const dispatchUserDocumentExist = pipe(
  setAction('user_document_exit|signup'),
  dispatchFrontendLoginEvent,
)

const dispatchUserEmailExist = pipe(
  setAction('user_email_exit|signup'),
  dispatchFrontendLoginEvent,
)

const dispatchUserAccountCreated = pipe(
  setAction('account_created|signup'),
  dispatchFrontendLoginEvent,
)

const dispatchSuccessLoginSignup = pipe(
  setLabel('signup_email'),
  setAction('successful_login'),
  dispatchFrontendLoginEvent,
)

const dispatchResendAccessCodeSignup = pipe(
  setLabel('signup_email'),
  setAction('resend_access_code'),
  dispatchFrontendLoginEvent,
)

const dispatchCreateAccountError = pipe(
  setReceivedLabel,
  setAction('account_creating_error|signup'),
  dispatchFrontendLoginEvent,
)

const dispatchLoginSignupError = pipe(
  setReceivedLabel,
  setAction('error_on_login|signup'),
  dispatchFrontendLoginEvent,
)

export {
  dispatchClickToSignup,
  dispatchUserDocumentExist,
  dispatchUserEmailExist,
  dispatchUserAccountCreated,
  dispatchSuccessLoginSignup,
  dispatchResendAccessCodeSignup,
  dispatchCreateAccountError,
  dispatchLoginSignupError,
}
